import styled from "@emotion/styled";

import { commonColors } from "application/theme";
import { ShareSmartBannerImage } from "application/assets";

export const Wrapper = styled("div")`
  height: 206px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 16px;
  gap: 16px;
  border-radius: 16px;
  background: url(${ShareSmartBannerImage});
  background-size: cover;

  > p {
    width: calc(100% - 26px);
    color: ${commonColors.white};
    font-family: Unica77;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;

    > span {
      color: ${commonColors.lemonPie};
    }
  }

  > button {
    all: unset;
    box-sizing: border-box;
    cursor: pointer;

    display: flex;
    height: 36px;
    padding: 20px 16px;
    align-items: center;
    gap: 10px;
    border-radius: 35px;
    background: ${commonColors.grey600};
    box-shadow: 0 4px 10px 0 rgba(26, 40, 104, 0.08);

    //font styles
    color: ${commonColors.white};
    text-align: center;
    font-family: "Unica77";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;
